import { combineReducers } from 'redux-immutable'
import { connectRouter } from 'connected-react-router/immutable'
import * as HouseReducer from '../House/Reducer'

export default (history) => combineReducers({
  router: connectRouter(history),
  house: HouseReducer.reducer,
})